import { render } from "./region.vue?vue&type=template&id=2c342744&ts=true"
import script from "./region.ts?vue&type=script&lang=ts&external"
export * from "./region.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__